// AIChatBot.js

import React, { Component } from "react";
import NewChat from "./NewChat";
import BackbuttonSVG from "../../../../Assets/svg/BackbuttonSVG.svg";
import ChatStarted from "./ChatStarted";
import AIInput from "./AIInput"; // Import AIInput
import PropTypes from "prop-types";
import { withRouterHooks } from "../../../../withRouters/withRoutersHook";
import { connect } from "react-redux";
import AIModelsList from "./AIModelsList";

class AIChatBot extends Component {
  static propTypes = {
    continueChatSessionId: PropTypes.number, // Changed to number
    isContinueChatSessionIdAddedToRedux: PropTypes.bool,
    navigate: PropTypes.func.isRequired,
  };

  handleChatStarted = () => {
    if (
      this.props.location.pathname.includes("/dashboard/ai-models/ai-chatbot/")
    ) {
      return <ChatStarted />;
    } else if (
      this.props.location.pathname === "/dashboard/ai-models/ai-chatbot"
    ) {
      return <NewChat />;
    }
  };

  handleBackToHome = () => {
    this.props.navigate("..");
  };

  render() {
    return (
      <div className="flex flex-col w-full h-full overflow-hidden relative">
        <AIModelsList />
        <button
          onClick={this.handleBackToHome}
          className="z-50 absolute top-4 right-4 md:top-6 md:right-6 flex gap-3 items-center p-2 rounded-lg text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors"
        >
          <div className="font-[400] text-[1rem] font-inter">Go back</div>
          <img src={BackbuttonSVG} alt="back button" className="w-5 h-5" />
        </button>
        <div className="flex-1 overflow-y-auto flex flex-col items-center">
          <div className="flex-grow w-full flex justify-center items-center py-8 bg-[radial-gradient(circle_at_top,#f2f7ff,transparent_42%),linear-gradient(180deg,#f8fbff_0%,#eef3f9_100%)]">
            {this.handleChatStarted()}
          </div>
        </div>
        <div className="w-full flex justify-center py-3 md:py-4 bg-white border-t border-gray-100">
          <div className="w-full max-w-3xl px-4 md:px-8">
            <AIInput />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  continueChatSessionId: state.ai.continueChatSessionId,
  isContinueChatSessionIdAddedToRedux:
    state.ai.isContinueChatSessionIdAddedToRedux,
});

export default withRouterHooks(connect(mapStateToProps)(AIChatBot));
